import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

export default function InvoiceOrderTable({ invoice, onDelete }) {
  const [expandedRows, setExpandedRows] = useState({});

  const handleToggleExpand = (orderId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [orderId]: !prev[orderId],
    }));
  };

  return (
    <div>
      {invoice?.type === "Order-Based" && invoice.items && (
        <>
          <Typography
            variant="h6"
            component="div"
            gutterBottom
            style={{ margin: "16px 0", textAlign: "center" }}
          >
            Order Details
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <b>Order ID</b>
                  </TableCell>
                  <TableCell>
                    <b>Order Date</b>
                  </TableCell>
                  <TableCell>
                    <b>Description</b>
                  </TableCell>
                  <TableCell>
                    <b>Quantity</b>
                  </TableCell>
                  <TableCell>
                    <b>Price</b>
                  </TableCell>
                  <TableCell>
                    <b>Total</b>
                  </TableCell>
                  <TableCell>
                    <b>Outstanding</b>
                  </TableCell>
                  <TableCell>
                    <b>Action</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoice.items.map((item, index) => (
                  <React.Fragment key={item.orderId || index}>
                    <TableRow>
                      <TableCell>{item.orderId}</TableCell>
                      <TableCell>{item.orderDate}</TableCell>
                      <TableCell>
                        {item.description}
                        {item.materialDetails && (
                          <IconButton
                            size="small"
                            onClick={() => handleToggleExpand(item.orderId)}
                          >
                            {expandedRows[item.orderId] ? (
                              <ExpandLessIcon />
                            ) : (
                              <ExpandMoreIcon />
                            )}
                          </IconButton>
                        )}
                      </TableCell>
                      <TableCell>{item.quantity}</TableCell>
                      <TableCell>${item.price}</TableCell>
                      <TableCell>${item.total}</TableCell>
                      <TableCell>${item.outstanding}</TableCell>
                      <TableCell>
                        <IconButton
                          color="error"
                          onClick={() => onDelete(item.orderId)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                    {item.materialDetails && expandedRows[item.orderId] && (
                      <TableRow>
                        <TableCell colSpan={8}>
                          <Table size="small" sx={{ backgroundColor: "#f9f9f9" }}>
                            <TableHead>
                              <TableRow>
                                <TableCell>
                                  <b>Material</b>
                                </TableCell>
                                <TableCell>
                                  <b>Quantity</b>
                                </TableCell>
                                <TableCell>
                                  <b>Selling Price</b>
                                </TableCell>
                                <TableCell>
                                  <b>Discount (%)</b>
                                </TableCell>
                                <TableCell>
                                  <b>Discount Amount</b>
                                </TableCell>
                                <TableCell>
                                  <b>Final Cost</b>
                                </TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {item.materialDetails.map((material, mIndex) => (
                                <TableRow key={mIndex}>
                                  <TableCell>{material.materialName}</TableCell>
                                  <TableCell>{material.quantity}</TableCell>
                                  <TableCell>${material.sellingPrice}</TableCell>
                                  <TableCell>{material.discountRate}%</TableCell>
                                  <TableCell>
                                    ${material.discountReducedAmount}
                                  </TableCell>
                                  <TableCell>${material.finalCost}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </div>
  );
}